if(! Window.getScrollPosition ) {
	Window.prototype.getScrollPosition = function() {
		return {
		    x: window.pageXOffset,
		    y: window.pageYOffset
		};
	}
}